import React, { useState } from 'react'; 
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import { useNavigate } from 'react-router-dom';
import '../../styles/timesheetStyles/TimesheetDetails.css';

const TimeSheetDetails = ({ children, activeTab, setActiveTab, tabsTitle = 'TimeSheets' }) => {
  const [status, setStatus] = useState('In Progress'); 

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const navigate = useNavigate();
  
  return (
    <div className="timesheetdetails-layout-container">
      <Header />
      <div className="timesheetdetails-content">
        <div className="timesheets-container">
          <h2 className="timesheetdetails-title">{tabsTitle}</h2>
          <div className="tabs">
            <button
              className={`tab-item ${activeTab === 'Timesheets Details' ? 'active' : ''}`}
              onClick={() => navigate('/timesheets')}
            >
              <img src="/images/back.svg" alt="New Project Icon" className="tab-icon" />
              Timesheets Details
              <img src="/images/Rectangle.png" alt="Additional" className="below-image" />
            </button>
          </div>
        </div>
        <div className="content-inner">{children}</div>
      </div>

      <div className="timesheetdetailsScreen">
      <div className="update-status">
          <div className="header-row">
            <h3>Timesheet Date</h3>
            <div className="status-badge" style={{ backgroundColor: status === 'Completed' ? '#8ABE14' : '#E59A0A' }}>
              <span>
                {status === 'In Progress' ? (
                  <img src="/images/in-progress.png" alt="In Progress Icon" className="icons-status"/>
                ) : (
                  <img src="/images/timesheetstatus.png" alt="Completed Icon" className="icons-status" />
                )}
                {status}
              </span>
            </div>
          </div>

          <div className="timesheet-details">
            <div className="timesheet-dates">
              <p>Start Date</p>
              <span>12th Jan, 2024</span>
            </div>
            <div className="timesheet-dates">
              <p>End Date</p>
              <span>19th Jan, 2024</span>
            </div>
          </div>
          <div className="timesheet-hrs">
            <p>Total Time</p>
            <span>17 Hrs</span>
          </div>

          <hr />

          <div className="status-section">
            <label className="status-sec">Status</label>
            <select value={status} onChange={handleStatusChange} className="custom-select">
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
            <span className="custom-arrow"></span>
          </div>

          <button className="update-button">Update Status</button>
        </div>
        <div className="main-container">

        <div className="addr-header-container">
            <h3 className="title-addr">05, Gill St, Toronto, ON</h3>
            <div className="edit-option">
        <img src="/images/edit.png" alt="Edit Icon" className="edit-icon" /> 
        <span className="edit">Edit</span>
        </div>
        </div>
 
        <div className="name-row">
        <h3 className="name-title">Jamie Chambers</h3>
                <div className="total-hrs">
        <span>Total Time: 10 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
            <h4 className="name-title">Construction and carpentry</h4>
        </div>
        <div className="name-row">
        <h3 className="name-title">Ethan Anderson</h3>
                <div className="total-hrs">
        <span>Total Time: 5 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
            <h4 className="name-title">Construction and carpentry</h4>
        </div>
        
        <div className="name-row">
        <h3 className="name-title">Chad Stevenson</h3>
                <div className="total-hrs">
        <span>Total Time: 12 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
            <h4 className="name-title">Construction and carpentry</h4>
        </div>
      </div>
      </div>
      <div className="button-section">
      <button className="export-button" >
      Export Excel </button>
      <button className="download-button" >
      Download Pdf </button>
</div>
      <Footer />
    </div>
  );
};

export default TimeSheetDetails;
